import { TRACKER_HEADER_SX } from "../trackerLayout";
import { Box, Button, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SatelliteAltOutlinedIcon from "@mui/icons-material/SatelliteAltOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { usePassSimulation } from "../PassPlanner/PassSimulationContext";
import { usePassPlanner } from "../PassPlanner/PassPlannerContext";
import { useAppSettings } from "../../context/AppSettingsContext";

export const FloatingMenuButton = () => {
  const { session } = usePassSimulation();
  const {
    open,
    openPlanner,
    closePlanner,
    satellitesOpen,
    openSatellites,
    closeSatellites,
  } = usePassPlanner();
  const { drawerOpen, setDrawerOpen } = useAppSettings();
  const panelOpen = open || satellitesOpen;
  const compactBrand = panelOpen || drawerOpen;

  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        ...TRACKER_HEADER_SX,
        pl: { xs: "max(12px, env(safe-area-inset-left, 0px))", md: 2.5 },
        pr: { xs: "max(12px, env(safe-area-inset-right, 0px))", md: 2.5 },
        bgcolor: "background.paper",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <IconButton
        onClick={() => setDrawerOpen((previous) => !previous)}
        aria-label="Open map settings"
        aria-expanded={drawerOpen}
        aria-controls="map-settings"
        sx={{ color: "text.secondary" }}
      >
        <MenuIcon sx={{ fontSize: 22 }} />
      </IconButton>
      <Box
        component="span"
        aria-hidden="true"
        sx={{
          fontSize: 26,
          lineHeight: 1,
          flexShrink: 0,
          display: { xs: compactBrand ? "block" : "none", sm: "block" },
          mr: { xs: compactBrand ? "auto" : 0, md: 0 },
        }}
      >
        🅰️
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: { xs: compactBrand ? "none" : "block", md: "block" },
        }}
      >
        <Typography
          component="h1"
          noWrap
          sx={{
            fontSize: 17,
            fontWeight: 650,
            lineHeight: 1.25,
            letterSpacing: "-0.4px",
          }}
        >
          Bluebird Tracker
        </Typography>
        <Typography
          noWrap
          sx={{ fontSize: 11, color: "text.secondary", mt: 0.25 }}
        >
          AST SpaceMobile constellation
        </Typography>
      </Box>
      <Button
        id="pass-planner-toggle"
        onClick={open ? closePlanner : openPlanner}
        aria-label="Open pass planner"
        aria-controls="pass-planner-panel"
        aria-expanded={open}
        variant="outlined"
        sx={{
          minWidth: { xs: 44, md: panelOpen ? 44 : 140 },
          minHeight: 44,
          gap: 1,
          color: "text.primary",
          borderColor: "divider",
        }}
      >
        <TravelExploreIcon sx={{ fontSize: 20 }} />
        {!panelOpen && (
          <Box component="span" sx={{ display: { xs: "none", md: "inline" } }}>
            Pass planner
          </Box>
        )}
      </Button>
      {!session && (
        <Button
          id="satellites-toggle"
          variant="outlined"
          aria-label="Satellites"
          onClick={satellitesOpen ? closeSatellites : openSatellites}
          aria-expanded={satellitesOpen}
          aria-controls="satellite-panel"
          sx={{
            display: { xs: "none", md: "inline-flex" },
            minHeight: 44,
            minWidth: 44,
            gap: 1,
            color: "text.primary",
            borderColor: "divider",
          }}
        >
          <SatelliteAltOutlinedIcon sx={{ fontSize: 18 }} />
          {!panelOpen && <Box component="span">Satellites</Box>}
        </Button>
      )}
    </Box>
  );
};
